import { enUS, tr } from "date-fns/locale";
import React, { Component } from "react";
import { registerLocale } from "react-datepicker";
import { renderToStaticMarkup } from "react-dom/server";
import { Helmet } from "react-helmet-async";
import { withLocalize } from "react-localize-redux";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import Router from "./App/Router";

import "./assets/app.scss";
import availableLanguages from "./utils/db/availableLanguages";
import global from "./utils/i18n/global.json";
import LanguageFiles from "./utils/i18n/LanguageFiles";
import { setLanguage, setProject, setProjects } from "./utils/redux/app/appActions";
import { login } from "./utils/redux/auth/authActions";
import "react-confirm-alert/src/react-confirm-alert.css";
import { setDefaultOptions } from "date-fns";
import InjectAxiosInterceptors from "./App/components/InjectAxiosInterceptors";
import API from "./utils/API";

export class App extends Component {
  state = {
    cacheCleared: false,
  };

  constructor (props) {
    super(props);

    this.props.initialize({
      languages: availableLanguages,
      translation: global,
      options: { renderToStaticMarkup },
    });

    registerLocale("tr", tr);
    registerLocale("en", enUS);
  }

  cookies = new Cookies();

  componentDidMount = () => {
    this.compareAppLanguageToCookies();

    const user = this.cookies.get("user");

    if (user?.isLoggedIn) {
      this.props.login(user);

      const project = JSON.parse(localStorage.getItem(`project-${user?.id}`));

      if (project) {
        this.props.setProject(project, user?.id);
      } else {
        this.props.setProject(null, user?.id);
      }
    }

    setDefaultOptions({
      locale: this.props.settings.language === "en" ? enUS : tr,
    });

    setTimeout(() => {
      this.setState({ cacheCleared: true });
    }, 50);
  };

  componentDidUpdate = (prevProps) => {
    if (
      !prevProps.user?.isLoggedIn &&
      this.props.user?.isLoggedIn &&
      this.props.user?.lang !== this.props.settings.language
    )
      this.props.setLanguage(this.props.user.lang);

    this.compareAppLanguageToCookies();

    if (prevProps.user?.isLoggedIn !== this.props.user?.isLoggedIn) {
      if (this.props.user?.isLoggedIn && this.props.user?.access_token) {
        API.getProjects({ type: "dropdown" }).then(({ data: res }) => {
          if (res.data)
            this.props.setProjects(res.data);
        }).catch(err => {
          console.log(err)
        });

        const project = JSON.parse(
          localStorage.getItem(`project-${this.props.user?.id}`),
        );

        if (project) {
          this.props.setProject(project, this.props.user?.id);
        } else {
          this.props.setProject(null, this.props.user?.id);
        }
      }
    }

    if (
      prevProps.project?.id &&
      prevProps.project?.id !== this.props.project?.id
    ) {
      localStorage.removeItem("selected-forms-location-root");
      localStorage.removeItem("selected-location-sets");
    }
  };

  compareAppLanguageToCookies = () =>
    this.props.settings &&
    this.props.activeLanguage &&
    this.props.settings.language !== this.props.activeLanguage.code
      ? this.props.setActiveLanguage(this.props.settings.language)
      : false;

  render () {
    return (
      <>
        <LanguageFiles
          addTranslationForLanguage={this.props.addTranslationForLanguage}
        />
        <InjectAxiosInterceptors/>
        <Helmet>
          <html
            className={`theme-${this.props.settings.theme}`}
            lang={this.props.settings?.language}
          />
        </Helmet>
        <div className="App">
          {this.state.cacheCleared && (
            <Router
              user={this.props.user}
              translate={this.props.translate}
              activeLanguage={this.props.activeLanguage}
              settings={this.props.settings}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.app.settings,
  user: state.auth.user,
  project: state.app.project,
});

const mapDispatchToProps = (dispatch) => ({
  login: (user) => dispatch(login(user)),
  setLanguage: (language) => dispatch(setLanguage(language)),
  setProject: (project, user) => dispatch(setProject(project, user)),
  setProjects: (projects) => dispatch(setProjects(projects)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(App));
